// extracted by mini-css-extract-plugin
export default {"drawerBodyContent":"DrawerBody-module__drawerBodyContent__p6a8Z"};